export enum GamificationActivityName {
    ACHIEVE = 'achieve',
    LEVEL_UP = 'level_up',
}

export enum GamificationActivityType {
    BADGE = 'badge',
    INBOX = 'inbox',
}

export enum GamificationConditionOperator {
    AND = 'and',
    OR = 'or',
}

// The types are agreed with business
// https://betgamestv.atlassian.net/wiki/spaces/DEVEL/pages/12064107/Data+sent+to+Captain+Up
// Depending on type different behaviour will be applied
export enum GamificationInboxTypes {
    LEVEL_UP = 'level_up',
}

export enum GamificationAssetType {
    SHOP = 'shop_item',
    TROPHY = 'trophy_item',
}

export enum GamificationCapType {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
}

export enum GamificationCurrency {
    POINTS = 'points',
    COINS = 'coins',
}

export enum GamificationCondition {
    PLACE_BET = 'place_bet',
    PAY_OUT = 'pay_out',
}

export enum GamificationConditionFilter {
    GAMES_IDS = 'game_ids',
    BET_AMOUNT = 'bet_amount',
    BET_STATUS = 'bet_status',
    ODD_VALUE = 'odd_value',
    ODD_CLASSES = 'odd_classes',
    ROUND_NUMBER = 'round_number',
    BET_ITEMS = 'bet_items',
}

export enum GamificationConditionFilterType {
    LESS_THAN = 'lt',
    LESS_THAN_OR_EQUAL_TO = 'lte',
    LESS_THAN_OR_EQUAL_TO_FIELD = 'lte_field',
    GREATER_THAN = 'gt',
    GREATER_THAN_OR_EQUAL_TO = 'gte',
    GREATER_THAN_OR_EQUAL_TO_FIELD = 'gte_field',
    DIVIDES_BY = 'divides_by',
    REACHES_MULTIPLE_OF = 'reaches_multiple_of',
    REACHES = 'quantity',
    IS_ONE_OF = 'eq',
    IS_NOT = 'ne',
    EXISTS = 'exists',
    DOES_NOT_EXIST = 'nexists',
    STARTS_WITH = 'start',
    LENGTH_IS = 'length_eq',
    DISTINCT_VALUES_EQUALS = 'distinct',
    CONTAINS = 'contains',
    DOES_NOT_CONTAIN = 'ncontains',
}

export enum GamificationTournamentType {
    ONGOING,
    UPCOMING,
    COMPLETED,
}

export enum GamificationAssetStatus {
    // Acquired on captain up side, and stored in BG DB
    PENDING = 'pending',
    // Successfully registered on partner side
    REGISTERED = 'registered',
    // Successfully assigned for player on HZ RGS side
    ASSIGNED = 'assigned',
}
